import { GET_FEEDBACK, UPDATE_FEEDBACK } from "../types";

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_FEEDBACK:
            return { ...state, list: payload };

        case UPDATE_FEEDBACK:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };

        default:
            return state;
    }
};

export default reducer;
